import React, {useState} from 'react'
import { Box, Grid, Hidden } from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import { DataGrid } from '@material-ui/data-grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CancelIcon from '@material-ui/icons/Cancel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Tooltip } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { makeStyles } from "@material-ui/core/styles"
import { useTheme } from "@material-ui/core/styles"
import {  withStyles } from "@material-ui/core";
const useStylesCustom = makeStyles(theme => ({
    deudaPendiente: {
      [theme.breakpoints.up('md')]: {
        marginLeft: '5%'
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: '-5%'
      }
    }
    
  }));
  const StyledDataGrid = withStyles({
    root: {
      "& .MuiDataGrid-renderingZone": {
        maxHeight: "none !important"
      },
      "& .MuiDataGrid-cell": {
        lineHeight: "unset !important",
        maxHeight: "none !important",
        whiteSpace: "normal"
      },
      "& .MuiDataGrid-row": {
        maxHeight: "none !important"
      }
    }
  })(DataGrid);
const useStyles = makeStyles({
    root: {
      padding: 10,
      display: 'flex',
    },
    connected: {
      marginRight: 2,
      color: '#4caf50',
    },
    disconnected: {
      marginRight: 2,
      color: '#d9182e',
    },
    dataGrid: {
        background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
        borderRadius: 3,
        border: 0,
        color: "white",
        height: 48,
        padding: "0 30px",
        boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
        width: "10"
      }
  });
  
  const columns = [
    { field: "id", headerName: "ID", width: 210,hide: true   }, 
    { field: "servicios", headerName: "Servicios", width: 100, height: 'auto', sortable: false, sortoptions: false,flex: 2,
    renderCell: (params) =>(
        <div >
               <p style={{width:'100%', whiteSpace: 'initial',lineHeight: '110%', fontSize:'10px', 
                        margin: '0px 0px', padding: '0px 0px', textAlign:'left'}}>
                    {params.value}
               </p>
        </div>
    )
    },  //hide: true   
    { field: "cantidad", headerName: "Cantidad", width: 114,sortable: false,flex: 1, minWidth: 98 },
    { field: "estado", headerName: "Estado", width: 124, flex: 2, 
        renderCell: (params) =>(
            <>
            {params.value == true ? (
                <div style={{ padding: 0,display: 'flex',}} >
                <FiberManualRecordIcon 
                    fontSize="small" 
                    style={{marginRight: 0,color: '#4caf50', marginTop:'14px'}} />
                    ACTIVO
            </div>
            )
            : ( 
                <div style={{ padding: 0,display: 'flex',}} >
                    <FiberManualRecordIcon 
                        fontSize="small"
                        style={{marginRight: 0,color: '#d9182e', marginTop:'14px'}} />
                        INACTIVO
                </div>
            )}
           </>
            // <p>{params.value == true ? "ACTIVO" : "INACTIVO"}</p>
        )
    },
    { field: "img", headerName: " ", type: "number", width: 80, hide: true,
        renderCell: () => (
            <img style={{width:'60%'}} src="https://img.icons8.com/ios/452/no-image-gallery.png" alt='sinimagen' ></img>
        )
    },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   width: 300,
    //   renderCell: (params) => (
    //     <a>hola : {
    //         params.value == "Snow@gmail.com" ? "aqui" : "otro" 


    //     }</a>
    //   )
    // }
  ];
  
  const rows = [
    {
        id:1,
        servicios: 'INTERNET GPON 20MB',
        cantidad: "1",
        estado: true,
        img: 35,
      //email: "Snow@gmail.com",
    // hide: false
    },
    {
        id:2,
        servicios: "TV ADICIONAL",
        cantidad: "1",
        estado: false,
        img: 35,
      //email: "Snow@gmail.com",
    // hide: false
    }
    // {
    //   id: 2,
    //   lastName: "Lannister",
    //   firstName: "Cersei",
    //   age: 42,
    //   email: "Lannister@gmail.com"
    // },
    // {
    //   id: 3,
    //   lastName: "Lannister",
    //   firstName: "Jaime",
    //   age: 45,
    //   email: "Lannister@gmail.com"
    // },
    // {
    //   id: 4,
    //   lastName: "Stark",
    //   firstName: "Arya",
    //   age: 16,
    //   email: "Stark@gmail.com"
    // },
    // {
    //   id: 5,
    //   lastName: "Targaryen",
    //   firstName: "Daenerys",
    //   age: null,
    //   email: "Targaryen@gmail.com"
    // },
    // {
    //   id: 6,
    //   lastName: "Melisandre",
    //   firstName: null,
    //   age: 150,
    //   email: "Melisandre@gmail.com"
    // },
    // {
    //   id: 7,
    //   lastName: "Clifford",
    //   firstName: "Ferrara",
    //   age: 44,
    //   email: "Clifford@gmail.com"
    // },
    // {
    //   id: 8,
    //   lastName: "Frances",
    //   firstName: "Rossini",
    //   age: 36,
    //   email: "Frances@gmail.com"
    // },
    // {
    //   id: 9,
    //   lastName: "Roxie",
    //   firstName: "Harvey",
    //   age: 65,
    //   email: "Roxie@gmail.com"
    // }
  ];

  function Transition(props) {
    return <Slide direction="up" {...props} />;
  }

  
const InfoDeudas = (props) => {
    
    const classes = useStyles
    const classesCustom =  useStylesCustom();

    
   const {contrato} = props 
   const [openModalState, setopenModal] = useState(false);
   const openModal = () => {
    setopenModal(true);
  };

  const closeModal = () => {
    setopenModal(false);
  };
    return (
        // <Card className={classes.root}>
            <Grid container style={{ marginLeft:'3%'}}>
                <Grid item xs={12} lg={12}>
                    <Typography style={{ color: '#616161', fontSize: 25}}>
                        Contrato: {contrato.codcontrato}
                    </Typography>
                </Grid>
                <Grid item xs={11} lg={5} md={6}>
                    <div > 
                        <DataGrid  
                            disableColumnFilter={false}
                            disableExtendRowFullWidth={true}
                            autoHeight={true}
                            style={{width: '100%'}}
                            rows={contrato.detalles}
                            columns={columns}
                            components={{
                                Footer:  () => <div style={{ display:'none', }}>hey a footer</div>,
                            }}
                            disableColumnSelector={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} lg={6} md={6} style={{marginTop:'20px',textAlign:'center'}}>
                        
                        <Box justifyContent="center">
                        <Grid container className={classesCustom.deudaPendiente}>
                            <Grid item 
                                  xs={12} xl={12} sm={6} lg={3}
                                  style={{ paddingTop:'0px'}}>
                                <Typography variant="h5" style={{ color: '#616161', marginTop:'14px'}}>
                                   <strong> Saldo <br></br>Pendiente</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} xl={12} sm={4} lg={3} style={{ textAlign:'center'}} >
                                { 
                                
                                    contrato.cantidadDeuda > 0 ? (
                                        <List style={{ paddingTop:'0rem', textAlign:'center'}}>
                                            <ListItem style={{ textAlign:'center', paddingTop:'0rem'}}>
                                                <ListItemText 
                                                            style={{fontSize: '3rem'}} 
                                                            secondary={
                                                                        <Button 
                                                                        variant="contained" 
                                                                        color="secondary"
                                                                        onClick={openModal}>
                                                                            Ver Detalle
                                                                        </Button>}>
                                                <span style={{ fontSize: "1.8rem", marginTop:'0px' }}>{`$${contrato.Total}`}</span>
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    ):(
                                        <Typography style={{ color: '#616161', marginTop:'30px', textAlign:'center'}}>
                                            <strong> <h2>Sin Deuda</h2></strong>
                                        </Typography>
                                    )
                                }
                            </Grid>
                            <Hidden xsDown mdDown>
                                <Grid item xs={4} lg={3} 
                                      style={{ paddingTop:'35px', marginLeft:'2rem'}}>
                                    <Avatar >
                                        <CancelIcon style={{ fontSize: 40, color:'#ec407a', backgroundColor:'#e0e0e0',  }} />
                                    </Avatar>
                                </Grid>                             
                            </Hidden>

                        </Grid>
                        </Box>

                </Grid>
                        <Dialog
                            open={openModalState}
                            fullWidth
                            maxWidth="md"
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={closeModal}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                        <DialogTitle id="alert-dialog-slide-title" style={{ textAlign:'center' }}>
                            {"DEUDAS VIGENTES"}
                        </DialogTitle>
                        <DialogContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Table style={{ borderCollapse: "collapse",
                                            width: "100%",
                                            paddingRight: "100",
                                            fontSize: "0.7em",
                                            fontFamily: "sans-serif",
                                            minWidth: "280px",
                                            boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)"}}>
                            <Thead>
                                <Tr style={{backgroundColor:"#f50057",
                                            color: "#ffffff",
                                            textAlign: "center"}}>
                                <Th style={{padding: "12px 15px"}}>NÚM. FACTURA</Th>
                                <Th style={{padding: "12px 15px"}}>FECHA</Th>
                                <Th style={{padding: "12px 15px"}}>VALOR</Th>
                                <Th style={{padding: "12px 15px"}}>PAGO</Th>
                                <Th style={{padding: "12px 15px"}}>DEUDA</Th>
                                <Th style={{padding: "12px 15px"}}>OBSERVACION</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {contrato.deudasPendiente.map((item, index) =>(
                                    <Tr key={index} style={{ borderBottom:" 1px solid #dddddd"}}>
                                        <Td style={{padding: "12px 15px"}}>{item.numFactura}</Td>
                                        <Td style={{padding: "12px 15px"}}>{item.fecha}</Td>
                                        <Td style={{padding: "12px 15px"}}>${item.valor}</Td>
                                        <Td style={{padding: "12px 15px"}}>${item.pago}</Td>
                                        <Td style={{padding: "12px 15px"}}>${item.deuda}</Td>
                                        <Td style={{padding: "12px 15px"}}>{item.observacion}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                            </Table>
                        </DialogContent>
                        <DialogActions style={{textAlign: "center"}}>
                            {/* <Button onClick={openModal} color="primary">
                                Disagree
                            </Button> */}
                            <Button onClick={closeModal} color="primary">
                                ACEPTAR
                            </Button>
                        </DialogActions>
                    </Dialog>
            </Grid>
        // </Card>
    )
}
    
export default InfoDeudas
